export function playSignupFanfare() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const note = (freq, start, dur, type = "sine", vol = 0.15) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = type;
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, ctx.currentTime + start);
      g.gain.exponentialRampToValueAtTime(vol, ctx.currentTime + start + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + dur);
      o.connect(g);
      g.connect(ctx.destination);
      o.start(ctx.currentTime + start);
      o.stop(ctx.currentTime + start + dur + 0.05);
    };
    // Rising major arpeggio + sparkle — bigger than the lead ping
    note(523.25, 0, 0.16, "triangle", 0.13);
    note(659.25, 0.13, 0.16, "triangle", 0.13);
    note(783.99, 0.26, 0.16, "triangle", 0.13);
    note(1046.5, 0.39, 0.5, "sine", 0.18);
    note(2093, 0.42, 0.4, "sine", 0.08);
    note(3135.96, 0.5, 0.35, "sine", 0.05);
    setTimeout(() => ctx.close(), 1400);
  } catch {
    /* audio blocked — silent no-op */
  }
}

export function playLeadAlertSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const note = (freq, start, dur, vol = 0.14) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, ctx.currentTime + start);
      g.gain.exponentialRampToValueAtTime(vol, ctx.currentTime + start + 0.015);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + dur);
      o.connect(g);
      g.connect(ctx.destination);
      o.start(ctx.currentTime + start);
      o.stop(ctx.currentTime + start + dur + 0.05);
    };
    note(880, 0, 0.18);
    note(1174.66, 0.16, 0.35);
    setTimeout(() => ctx.close(), 900);
  } catch {
    /* audio blocked — silent no-op */
  }
}

export function playCashSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const note = (freq, start, dur, type = "sine", vol = 0.15) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = type;
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, ctx.currentTime + start);
      g.gain.exponentialRampToValueAtTime(vol, ctx.currentTime + start + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + dur);
      o.connect(g);
      g.connect(ctx.destination);
      o.start(ctx.currentTime + start);
      o.stop(ctx.currentTime + start + dur + 0.05);
    };
    note(2093, 0, 0.07, "square", 0.07);
    note(2637, 0.09, 0.5, "sine", 0.18);
    note(3520, 0.09, 0.45, "sine", 0.11);
    note(1318, 0.09, 0.35, "triangle", 0.07);
    setTimeout(() => ctx.close(), 1200);
  } catch {
    /* audio blocked — silent no-op */
  }
}
